import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, KeyRound } from "lucide-react";

export const SecuritySettings = () => {
  const { token, admin, login } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("New passwords do not match"); return; }
    if (form.new_password.length < 12) { toast.error("Use at least 12 characters"); return; }
    setSaving(true);
    try {
      const res = await axios.post(`${API}/auth/change-password`, { current_password: form.current_password, new_password: form.new_password }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.token) login(res.data.token, admin);
      toast.success("Password updated — use it next time you log in");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (error) {
      const d = error.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Failed to update password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-security">
      <h1 className="font-heading text-3xl text-charcoal mb-2 flex items-center gap-3"><ShieldCheck className="w-6 h-6 text-jade-text" /> Security</h1>
      <p className="font-body text-stone-grey mb-8">Signed in as <span className="text-charcoal">{admin?.email}</span>. Logins lock for 15 minutes after 5 failed attempts.</p>
      <form onSubmit={submit} noValidate className="glass rounded-xl p-6 max-w-lg space-y-4">
        <h2 className="font-heading text-lg text-charcoal flex items-center gap-2"><KeyRound className="w-4 h-4 text-jade-text" /> Change password</h2>
        <div>
          <Label className="font-body text-sm text-stone-grey mb-1 block">Current password</Label>
          <Input data-testid="security-current-password" type="password" autoComplete="current-password" required value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="form-input" />
        </div>
        <div>
          <Label className="font-body text-sm text-stone-grey mb-1 block">New password <span className="text-taupe">(12+ characters)</span></Label>
          <Input data-testid="security-new-password" type="password" autoComplete="new-password" required value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="form-input" />
        </div>
        <div>
          <Label className="font-body text-sm text-stone-grey mb-1 block">Confirm new password</Label>
          <Input data-testid="security-confirm-password" type="password" autoComplete="new-password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="form-input" />
        </div>
        <Button type="submit" className="btn-primary" disabled={saving} data-testid="security-save-btn">{saving ? "Saving..." : "Update password"}</Button>
      </form>
    </div>
  );
};
